import { isValidDate } from './isValidDate';

export function validateAllowedDays(date, days = []) {
  return isValidDate(date) && days.some((day) => day === date.getDay());
}
